import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getCurrentAccountAdapter} from 'main/adapters/current-account-adapter';
import {formatGender} from 'presentation/utils/formatGender';

import {UseGetExamsListProps} from './types';
import {getExamsList} from '../../services/getExamsList';

function useGetExamsListQuery(params: UseGetExamsListProps) {
	const {
		beneficiary: {flSexoUsuarioC, idadeC},
	} = getCurrentAccountAdapter();
	const genderFormatted = formatGender(flSexoUsuarioC);

	return useQuery({
		queryKey: [QUERY_KEYS.EXAMS_LIST, params, genderFormatted, idadeC],
		queryFn: ({signal}) =>
			getExamsList({...params, gender: genderFormatted, age: idadeC, signal}),
		retry: 1,
	});
}

export {useGetExamsListQuery};
